import React from "react";
import { View, StyleSheet, Text, Platform } from "react-native";

import { cardShadow } from "../../../../styles/shadows";
import cardStyles from "../../home/cards/cardStyles";
import AppTheme from "../../AppTheme";

import ImageComponent from "../../common/ImageComponent";
import MariTalkingIcon from "../../common/ActionsMenuButton/mari/MariTalkingIcon";
import SnoozeIcon from "../../common/dialog/SnoozeIcon";

export default function MessageCard(props) {
  const { username, time, message, avatar } = props;

  return (
    <View style={styles.card}>
      <SnoozeIcon style={cardStyles.closeButton} onPress={() => {}} />
      {avatar ? (
        <ImageComponent style={styles.imageIcon} image={avatar} />
      ) : (
        <MariTalkingIcon style={styles.imageIcon} width="28" height="28" />
      )}

      <View style={styles.info}>
        <Text style={styles.username}>{username}</Text>
        <Text style={styles.time}>Sent at {time}</Text>
        <Text style={styles.text}>{message}</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    position: "relative",
    backgroundColor: "#FFF",
    borderRadius: 4,
    marginBottom: 8,
    paddingLeft: 8,
    paddingRight: 3,
    paddingVertical: 8,
    marginHorizontal: 2,
    //minHeight: 86,
    height: "auto",
    ...cardShadow,
    elevation: 3,
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "row",
  },
  imageIcon: {
    width: 28,
    height: 28,
    borderRadius: 28,
    marginRight: 8,
  },
  info: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    flex: 1,
  },
  username: {
    width: "100%",
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
  time: {
    width: "100%",
    marginTop: 2,
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "300",
    fontSize: 10,
    lineHeight: "normal",
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
  text: {
    width: "100%",
    marginTop: 2,
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "300",
    fontSize: 12,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
});
